import { useEffect } from 'react'
import BottomSheetContent from '../../../../components/BottomSheetComponents/BottomSheetContent'
import { PrimaryButton } from '../../../../components/execution/PrimaryButton'
import { EventNames } from '../../../../types/misc.types'
import { trackEvent } from '../../../../utils/appBridge'
import { PlansBottomSheet, PlansExecutionEventIds, PlansScreen } from '../analytics/plansEvents'

export function RegularFundNotSupportedBottomSheet({
  onDismiss,
  analyticsScreen = PlansScreen.LumpsumAllocation,
  fundName = '',
  fundIsin = ''
}: {
  onDismiss: () => void
  analyticsScreen?: string
  fundName?: string
  fundIsin?: string
}) {
  useEffect(() => {
    trackEvent({
      eventName: EventNames.BottomSheetLoad,
      payload: {
        ScreenName: analyticsScreen,
        eventId: PlansBottomSheet.RegularFundNotSupported,
        bottomSheetName: PlansBottomSheet.RegularFundNotSupported,
        ...(fundName ? { fundName } : {}),
        ...(fundIsin ? { fundIsin } : {})
      }
    })
  }, [analyticsScreen, fundIsin, fundName])

  function handleClose() {
    trackEvent({
      eventName: EventNames.ButtonTap,
      payload: {
        ScreenName: analyticsScreen,
        eventId: PlansExecutionEventIds.RegularSheetClose,
        buttonLabel: 'Close',
        ...(fundName ? { fundName } : {}),
        ...(fundIsin ? { fundIsin } : {})
      }
    })
    onDismiss()
  }

  return (
    <BottomSheetContent
      heading="Regular funds cannot be sold through PowerUp Money app"
      bottomSheetHeadingClassName="!font-[500] !leading-[130%] !text-[22px]"
      onDismiss={handleClose}
      bottomSheetCtas={
        <PrimaryButton
          testLocator="BS_CTA_PRIMARY"
          label="Close"
          primaryButtonClassName="!h-[56px] text-[16px]"
          onClick={handleClose}
        />
      }
    >
      <div className="pb-2 text-[14px] font-[400] leading-[150%] text-[#6A6E6E]">
        We currently support investments and withdrawals only for Direct funds. Since this investment is in
        a Regular fund, you will need to sell it through the platform where you originally invested in this
        fund.
      </div>
    </BottomSheetContent>
  )
}
